'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _helperEvents = require('@rnb/helper-events');

var _uiNavDots = require('./ui-nav-dots.less');

var _uiNavDots2 = _interopRequireDefault(_uiNavDots);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UiNavDots = function (_Component) {
    _inherits(UiNavDots, _Component);

    function UiNavDots(props) {
        _classCallCheck(this, UiNavDots);

        var _this = _possibleConstructorReturn(this, (UiNavDots.__proto__ || Object.getPrototypeOf(UiNavDots)).call(this, props));

        _this.state = {
            isSmallDevice: true
        };
        return _this;
    }

    _createClass(UiNavDots, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this.onResizeWindowWidthSubscription = _helperEvents.EventAggregator.subscribe("onResizeWindowWidth", function (windowWidth) {
                return _this2.windowWidthChanged(windowWidth);
            });
            this.setState({ isSmallDevice: (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) < 768 });
            _helperEvents.EventAggregator.initListeners();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.onResizeWindowWidthSubscription.remove();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var list = [];
            var dynamicCssStyles = this.getDynamicCssStyles();

            for (var i = 0, iMax = this.props.lastPage; i < iMax; i++) {
                list.push({});
            }

            return _react2.default.createElement(
                _react.Fragment,
                null,
                this.props.lastPage > 1 && _react2.default.createElement(
                    'div',
                    { style: dynamicCssStyles.cssListWidth, className: ["ui-nav-dots", this.state.isSmallDevice && this.props.lastPage > 5 ? "ui-nav-dots--dynamic-presentation" : ""].join(" ") },
                    _react2.default.createElement(
                        'ul',
                        { style: dynamicCssStyles.cssListPostLeft, className: "ui-nav-dots__list" },
                        list.map(function (node, i) {
                            return _react2.default.createElement(
                                'li',
                                { key: _this3.generateKey(i), style: dynamicCssStyles.cssListItemWidth, className: ["ui-nav-dots__list-item", _this3.getDotPresentation(i)].join(" ") },
                                _react2.default.createElement('span', { className: ["ui-nav-dots__list-item-dot", _this3.props.page === i + 1 ? "ui-nav-dots__list-item-dot--active" : '', _this3.props.classNameListItemDot ? _this3.props.classNameListItemDot : ""].join(" ") })
                            );
                        })
                    )
                )
            );
        }
    }, {
        key: 'windowWidthChanged',
        value: function windowWidthChanged(windowWidth) {
            var isSmallDevice = windowWidth < 768;

            if (isSmallDevice !== this.state.isSmallDevice) {
                this.setState({ isSmallDevice: isSmallDevice });
            }
        }
    }, {
        key: 'getDynamicCssStyles',
        value: function getDynamicCssStyles() {
            var adjustLeft = 0;
            var pageMaxMultipler = void 0;

            if (this.props.lastPage > 5 && this.state.isSmallDevice) {
                if (this.props.page > 3) {
                    pageMaxMultipler = this.props.page > 5 ? 5 : this.props.page;

                    if (this.props.page > 5) {
                        adjustLeft = (this.props.page - 5) * -this.props.dotSize;
                    }
                } else {
                    pageMaxMultipler = 3;
                }

                return {
                    cssListWidth: { width: pageMaxMultipler * this.props.dotSize + this.props.dotSize * 2 + 'px' },
                    cssListPostLeft: { left: adjustLeft + 'px', width: this.props.lastPage * this.props.dotSize + 'px' },
                    cssListItemWidth: { width: this.props.dotSize + "px" }
                };
            } else {
                return {
                    cssListWidth: { width: "" },
                    cssListPostLeft: { left: "" },
                    cssListItemWidth: { width: "" }
                };
            }
        }
    }, {
        key: 'getDotPresentation',
        value: function getDotPresentation(listItemIndex) {
            if (!this.state.isSmallDevice || this.lastPage < 6) {
                return "";
            }

            var liIndex = parseInt(listItemIndex) ? parseInt(listItemIndex) : 0;

            if (this.props.page > 3) {

                if (this.isRightOfActive(listItemIndex)) {
                    return "ui-nav-dots__list-item--scale-small";
                } else if (this.isSecondRightOfActive(listItemIndex) || this.isThirdRightOfActive(listItemIndex)) {
                    return "ui-nav-dots__list-item--scale-smallest";
                }

                if (this.isLastVisibleOnLeftSideAfterFourPagings(liIndex)) {
                    return "ui-nav-dots__list-item--scale-smallest";
                } else if (this.isSecondLastVisibleOnLeftSideAfterFourPagings(liIndex)) {
                    return "ui-nav-dots__list-item--scale-small";
                }
            } else {
                if (this.isFourthElementBeforeFourPagings(liIndex)) {
                    return "ui-nav-dots__list-item--scale-small";
                } else if (this.isFifthElementBeforeFourPagings(liIndex)) {
                    return "ui-nav-dots__list-item--scale-smallest";
                }
            }
        }
    }, {
        key: 'isRightOfActive',
        value: function isRightOfActive(listItemIndex) {
            return this.props.page === listItemIndex ? true : false;
        }
    }, {
        key: 'isSecondRightOfActive',
        value: function isSecondRightOfActive(listItemIndex) {
            return this.props.page === listItemIndex - 1 ? true : false;
        }
    }, {
        key: 'isThirdRightOfActive',
        value: function isThirdRightOfActive(listItemIndex) {
            return this.props.page === listItemIndex - 2 ? true : false;
        }
    }, {
        key: 'isLastVisibleOnLeftSideAfterFourPagings',
        value: function isLastVisibleOnLeftSideAfterFourPagings(liIndex) {
            return liIndex - this.props.page <= -5 ? true : false;
        }
    }, {
        key: 'isSecondLastVisibleOnLeftSideAfterFourPagings',
        value: function isSecondLastVisibleOnLeftSideAfterFourPagings(liIndex) {
            return liIndex - this.props.page === -4 ? true : false;
        }
    }, {
        key: 'isFourthElementBeforeFourPagings',
        value: function isFourthElementBeforeFourPagings(liIndex) {
            return liIndex === 3 ? true : false;
        }
    }, {
        key: 'isFifthElementBeforeFourPagings',
        value: function isFifthElementBeforeFourPagings(liIndex) {
            return liIndex === 4 ? true : false;
        }
    }, {
        key: 'generateKey',
        value: function generateKey(pre) {
            return pre + '_' + new Date().getTime();
        }
    }]);

    return UiNavDots;
}(_react.Component);

UiNavDots.defaultProps = {
    page: 0,
    lastPage: 0,
    dotSize: 16,
    classNameListItemDot: ""
};
exports.default = UiNavDots;